import { isFilled } from '@prismicio/client';
import { PrismicItemTitleStyleField } from '@monofront/types';

export const usePrismicTitleStyle = (
  titleStyleField: PrismicItemTitleStyleField | undefined,
) => {
  const titleStyle = (() => {
    if (!isFilled.select(titleStyleField)) {
      return '';
    }

    switch (titleStyleField) {
      case 'subtitle':
        return 'tw-uppercase tw-lf-subtitle-md';
      case 'title':
        return 'tw-normal-case tw-lf-title-sm';
      default:
        return '';
    }
  })();

  return titleStyle;
};
